export default class SearchPageController {
  constructor(Task, MysolvrEntry, $stateParams) {
    'ngInject';

    this.$stateParams = $stateParams;
    this.Task = Task;
    this.MysolvrEntry = MysolvrEntry;
  }

  $onInit() {
    this.tasks = [];
    this.mysolvrEntries = [];
    this.taskTypes = [
      { value: 'tasks', label: 'Tasks', selected: true },
      { value: 'mysolvr_entries', label: 'My Solvr'},
    ];
  }

  loadMore() {
    this.page += 1;
    this.loadItems(this.selectedType);
  }

  loadTasks(params = {}) {
    const oldTasks = this.tasks;
    this.loading = true;
    this.Task.query(params).$promise
      .then((response) => {
        this.meta = response.meta;
        this.lastResponse = response.tasks;
        this.tasks.push(...response.tasks);
        this.loading = false;
      })
      .catch((error) => {
        this.tasks = oldTasks;
        this.loading = false;
      });
  }


  loadMysolvrEntries(params = {}) {
    const oldMysolvrEntries = this.mysolvrEntries;
    this.loading = true;
    this.MysolvrEntry.query(this.searchParams).$promise
      .then((response) => {
        this.meta = response.meta;
        this.lastResponse = response.mysolvr_entries;
        this.mysolvrEntries.push(...response.mysolvr_entries);
        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
        this.mysolvrEntries = oldMysolvrEntries;
      });
  }

  loadItems(selectedType = 'tasks') {
    if (selectedType === 'tasks') {
      this.loadTasks({keywords: this.$stateParams.keywords, page: this.page});
    } else if (selectedType === 'mysolvr_entries') {
      this.loadMysolvrEntries({keywords: this.$stateParams.keywords, page: this.page});
    }
  }

  onTypeSelect(option) {
    this.page = 1;

    this.selectedType = option.value;

    this.loadItems(this.selectedType);
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/search-page/search-page.controller.js